// extracted by mini-css-extract-plugin
var _1 = "f1-vr__gameLink";
var _2 = "f1-vr__gameLink_active";
var _3 = "f1-vr__gameLink_disabled";
var _4 = "f1-vr__games";
var _5 = "f1-vr__gamesList";
var _6 = "f1-vr__img";
var _7 = "f1-vr__text";
export { _1 as "gameLink", _2 as "gameLink_active", _3 as "gameLink_disabled", _4 as "games", _5 as "gamesList", _6 as "img", _7 as "text" }
